export default __webpack_public_path__ + "static/media/cpr4.684df9ec.jpg";